__webpack_require__.p = "https://ikea.marat.qd.je/sa/en/local-apps/alsulaiman-purchase-handler/";